import useSignature from '@/common/hooks/useSignature';

export enum FileFaEnum {
  'Initial' = 'بیمه‌گذار',
  'PropertyDamaged' = 'زیان دیده',
  'PropertyCulprit' = 'مقصر',
  'Body' = 'بیمه‌گذار',
}

export type SignatureViewProps = {
  isLoading: boolean;
  signatureImage?: string;
  editable: boolean;
  signatureProps: ReturnType<typeof useSignature>;
  onOpenConfirmation: () => void;
  confirmationOpen: boolean;
  onCloseConfirmation: () => void;
  onSubmitSignature: () => void;
  postLoading: boolean;
  patchLoading: boolean;
  type: keyof typeof FileFaEnum;
};
